import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpClient } from "../../HttpClient";


// export const CreatePMPlan = createAsyncThunk("createPMplan", async (data) => {
//     try {
//         const postAllData = await fetch(`/internal/db/maintainence_models/pm/plan`, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify(data),
//         });
//         const response = await postAllData.json();
//         const StatusCode = postAllData.status;
//         const result = response.Result;
//         console.log("success in postAllData", response);
//         return {
//             response,
//             result,
//             StatusCode
//         }
//     } catch (error) {
//         console.log("Error:", error)
//         throw error;
//     }
// }
// );

export const postBD_Category = createAsyncThunk("post_BDCategory", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/setting/category`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const postBD_Reasons = createAsyncThunk("postBD_Reasons", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/setting/reason`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBd_category = createAsyncThunk("BD-Category", async (customer_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/setting/category?customer_id=${customer_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Category", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);


export const getBd_reason = createAsyncThunk("BD-Reason", async (customer_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/setting/reason?customer_id=${customer_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBDStatus = createAsyncThunk("getBDStatus", async () => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/setting/status?customer_id=af33f9117ecb4d8d8def84d6331eebd4`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const getUserReadable = createAsyncThunk("getUserReadable", async () => {
    // /userapp/user/readable
    // /internal-db/internal/db/usermodels/user/readable
    try {
        const getAllData = await httpClient.get(`/internal-db/internal/db/usermodels/user/readable`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const reportBreakDown = createAsyncThunk("reportBreakDown", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/report`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBreakdowns = createAsyncThunk("getBreakdowns", async (queryParams) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/search${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});



export const attendBreakDown = createAsyncThunk("attendBreakDown", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/attendance`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBreakdownDetails = createAsyncThunk("getBreakdownDetails", async (breakdown_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/details?breakdown_id=${breakdown_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const getUserList = createAsyncThunk("getUserList", async (asset_id) => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/user/list?resource_name=bd_approvers&machine_id=${asset_id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const getPendingApprovals = createAsyncThunk("getPendingApprovals", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/search${queryParams}&approval_status=false`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});

export const approveBreakDown = createAsyncThunk("approveBreakDown", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/approval`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const AddBDNotes = createAsyncThunk("AddNotes", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/notes`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const doneRCA = createAsyncThunk("doneRCA", async (data) => {
    try {
        const getAllData = await httpClient.post(`/maintenanceapp/breakdown/rca`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting all BD Reason", response);
        return {
            result,
            StatusCode
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
}
);

export const getBreakdownLogs = createAsyncThunk("getBreakdownLogs", async (queryParams = "") => {
    try {
        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/search${queryParams}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});


export const getBD_Reports = createAsyncThunk("getBD_Reports", async ({ asset_id, freq, fromTime, toTime }) => {
    try {
        // /maintenanceapp/breakdown/stats?from_time=2024-09-20 00:30:00&freq=day&asset_ids=ebcf0f30-e94b-49cc-8b64-64b218f3d8a9
        // /maintenanceapp/breakdown/stats?from_time=${fromTime}&freq=${freq}&asset_ids=${asset_id}

        const getAllData = await httpClient.get(`/maintenanceapp/breakdown/stats?asset_ids=${asset_id}&freq=${freq}&from_time=${fromTime}&to_time=${toTime}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const response = await getAllData.data;
        const StatusCode = getAllData.status;
        const result = response.Result;
        console.log("success in getting default checkpoints", response);
        return {
            result,
            StatusCode
        };
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const backendMessage = error.response.data?.Message || "An error occurred while processing the request";
            throw new Error(backendMessage);
        } else {
            throw new Error("Something went wrong, please try again later.");
        }
    }
});



const BreakdownSlice = createSlice({
    name: "BreakdownSlice",
    initialState: {
        loading: false,
        error: null,
        response: null,
        reason: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBd_category.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getBd_category.fulfilled, (state, action) => {
                state.loading = false;
                state.response = action.payload.result;
            })
            .addCase(getBd_category.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getBd_reason.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getBd_reason.fulfilled, (state, action) => {
                state.loading = false;
                state.reason = action.payload.result;
            })
            .addCase(getBd_reason.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
})


export default BreakdownSlice.reducer;